<template>
  <div v-if="sectionData && sectionData[0] && sectionData[0].page_sections">
    <div class="container-fluid overflow-hidden" v-for="(section) in sortedSections" :key="section.id"
      :style="{ backgroundColor: section.bg_color }">
      <div :class="getColClass(section.addditonal_json, 'row')">

        <div :class="getColClass(section.addditonal_json, 'col2')" :style="{ backgroundColor: section.bg_color }">
          <div :class="getColClass(section.addditonal_json, 'header1')">{{ section.header_text_1 }}</div>
          <div :class="getColClass(section.addditonal_json, 'header2')">{{ section.header_text_2 }}</div>
          <div v-if="section.desc_1" :class="getColClass(section.addditonal_json, 'desc1')"
            v-html="`${section.desc_1}`">
          </div>
          <div v-if="section.desc_2" :class="getColClass(section.addditonal_json, 'desc2')"
            v-html="`${section.desc_2}`">
          </div>
          <div v-if="section.desc_3" :class="getColClass(section.addditonal_json, 'desc3')"
            v-html="`${section.desc_3}`">
          </div>

          <div :class="getColClass(section.addditonal_json, 'btn_hld')">
            <div>
              <template v-if="section.button_1_link">
                <a v-if="isExternalLink(section.button_1_link)" :href="section.button_1_link" target="_blank"
                  rel="noopener noreferrer">
                  <div :class="getColClass(section.addditonal_json, 'btn1')" type="button">
                    {{ section.button_1_text }}
                  </div>
                </a>
                <router-link v-else :to="section.button_1_link">
                  <div :class="getColClass(section.addditonal_json, 'btn1')" type="button">
                    {{ section.button_1_text }}
                  </div>
                </router-link>
              </template>
            </div>
            <div>
              <template v-if="section.button_2_link">
                <a v-if="isExternalLink(section.button_2_link)" :href="section.button_2_link" target="_blank"
                  rel="noopener noreferrer">
                  <div :class="getColClass(section.addditonal_json, 'btn2')" type="button">
                    {{ section.button_2_text }}
                  </div>
                </a>
                <router-link v-else :to="section.button_2_link">
                  <div :class="getColClass(section.addditonal_json, 'btn2')" type="button">
                    {{ section.button_2_text }}
                  </div>
                </router-link>
              </template>
            </div>
          </div>
        </div>

        <div :class="getColClass(section.addditonal_json, 'col1')" :style="{ backgroundColor: section.bg_color }"
          :ref="el => { if (el) sectionImgRefs[section.id] = el }">
          <img :src="sectionData ? `${$API_ASSETS}${section.display_image.id}?width=1200&quality=80` : 'white'"
            class="img-fluid w-100 section-img"
            :class="{ 'section-img-visible': visibleSections[section.id] }"
            alt="globe" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'PageSections',
  props: {
    sectionId: {
      type: Number,
      required: true, // Ensure the prop is passed
    },
  },
  data() {
    return {
      sectionData: null,
      visibleSections: {},
      sectionImgRefs: {},
    };
  },
  computed: {
    sortedSections() {
      if (this.sectionData && this.sectionData[0] && this.sectionData[0].page_sections) {
        // Create a copy of the page_sections array before sorting it
        return [...this.sectionData[0].page_sections].sort((a, b) => a.order - b.order);
      }
      return [];
    },
  },
  methods: {
    async fetchSectionData() {
      const url = this.$API_GRAPHQL;
      try {
        const response = await axios.post(
          url,
          {
            query: `
                query {
                  page_section_holder(filter: { id: { _eq: ${this.sectionId}} }) {
                    id
                    name
                    page_sections {
                      id
                      header_text_1
                      header_text_2
                      desc_1
                      desc_2
                      desc_3
                      right_text
                      button_1_text
                      button_1_link
                      button_2_text
                      button_2_link
                      bg_color
                      order
                      addditonal_json
                      display_image {
                        id
                      }
                    }
                  }
                }
              `,
          },
          {
            headers: {
              Authorization: `Bearer Pm4Nd5_e46HaK2xtkPcla2PMBzbk9AQf`,
              'Content-Type': 'application/json',
            },
          }
        );

        this.sectionData = response.data.data.page_section_holder;
        console.log('Home Page Data:', this.sectionData);
        this.$nextTick(() => {
          let initialized = false;
          setTimeout(() => { initialized = true; }, 200);
          Object.entries(this.sectionImgRefs).forEach(([id, el]) => {
            if (!el) return;
            const observer = new IntersectionObserver((entries) => {
              if (initialized && entries[0].isIntersecting) {
                this.visibleSections = { ...this.visibleSections, [id]: true };
                observer.disconnect();
              }
            }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
            observer.observe(el);
          });
        });
      } catch (error) {
        console.error('Error fetching home page data:', error);
      }
    },
    getColClass(additionalJson, col) {
      if (!additionalJson || !additionalJson[col]) {
        return col === 'd-none';
      }
      return additionalJson[col];
    },
    isExternalLink(link) {
      return /^(https?:\/\/)/.test(link);
    },
  },
  created() {
    this.fetchSectionData();
  },
};
</script>

<style scoped>
.section-img {
  transform: translateX(80px);
  opacity: 0;
  transition: transform 1.5s ease, opacity 1.5s ease;
}

.section-img.section-img-visible {
  transform: translateX(0);
  opacity: 1;
}
</style>
